class window.BilletinResizeImages
  constructor: ->
    @container = $(".bulletin-static-content")
    @titleBlock = $(".bulletin-static-content *[title*='header']")
    @tables = $("table")
    @init()

  init:->
    @titleBlock.remove()

    images = $(@container.find("img"))
    images.each ->
      $(this).attr("style", "width: " + $(this).attr("width") + "px !important")
      $(this).attr("style", "height: " + $(this).attr("height") + "px !important")



// WEBPACK FOOTER //
// ./assets/javascripts/app/bulletin_resize_images.coffee